import {
	type ExperienceData,
	type ExperiencePerformanceConfig as PerformanceConfig,
} from '@atlassian/ufo-experimental/types';

import { CustomMetricKeys } from './CustomMetricKeys';
import { getHistogram } from './getHistogram';

export const getCustomMetrics = (
	data: ExperienceData,
	performanceConfig: PerformanceConfig | null,
): {
	[x: string]: string | number;
} | null => {
	if (data.metrics.endTime === null || data.metrics.startTime === null) {
		return null;
	}

	const duration = data.metrics.endTime - data.metrics.startTime;
	return {
		[CustomMetricKeys.duration]: Math.round(duration),
		...getHistogram(data, performanceConfig),
	};
};
